import { Box, Grid, Typography } from '@mui/material';

const companyLogos = Object.freeze([
  {
    id: 'americanExpress',
    name: 'American Express',
    order: 1,
    imgUrl:
      'https://www.nerdwallet.com/cdn/performance-marketing-client/company-logos/american-express.png',
  },
  {
    id: 'bankOfAmerica',
    name: 'Bank of America',
    order: 2,
    imgUrl:
      'https://www.nerdwallet.com/cdn/performance-marketing-client/company-logos/bank-of-america.png',
  },
  {
    id: 'capitalOne',
    name: 'Capital One',
    order: 3,
    imgUrl:
      'https://www.nerdwallet.com/cdn/performance-marketing-client/company-logos/capital-one.png',
  },
  {
    id: 'chase',
    name: 'Chase',
    order: 4,
    imgUrl:
      'https://www.nerdwallet.com/cdn/performance-marketing-client/company-logos/chase.png',
  },
  {
    id: 'citi',
    name: 'Citi',
    order: 5,
    imgUrl:
      'https://www.nerdwallet.com/cdn/performance-marketing-client/company-logos/citibank.png',
  },
  {
    id: 'wellsFargo',
    name: 'Wells Fargo',
    order: 6,
    imgUrl:
      'https://www.nerdwallet.com/cdn/performance-marketing-client/company-logos/wells-fargo.png',
  },
]);

const LABEL = 'Our partners include';

// Taken from the CardFinder's Branded LP Figma
const BACKGROUND_COLOR = '#EFFCF8';

export const PartnersSection = () => (
  <Box
    display="flex"
    justifyContent="center"
    flexDirection="column"
    alignItems="center"
    paddingY={{ xs: 6, xl: 10.5 }}
    gap={3.5}
    bgcolor={BACKGROUND_COLOR}
  >
    <Typography
      textAlign="center"
      variant="textLargeBold"
      component="h2"
      fontSize={24}
    >
      {LABEL}
    </Typography>
    <Box marginTop={{ xs: 3, xl: 5 }} marginLeft={3} maxWidth={'100%'}>
      <Grid
        columnSpacing={{ xs: 3, xl: 8 }}
        rowSpacing={{ xs: 4, xl: 6 }}
        columns={{ xs: 2, xl: 6 }}
        alignItems="center"
        justifyContent="center"
        display="flex"
        container
      >
        {companyLogos.map((logo) => (
          <Grid
            item
            key={logo.id}
            display="flex"
            alignItems="center"
            justifyContent="center"
            order={logo.order}
            marginBottom={{ xs: 3.5, md: 0 }}
            maxWidth={{ xs: '160px', xl: '100%' }}
            xs={1}
            xl={1}
          >
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img
              src={logo.imgUrl}
              alt={logo.name}
              style={{ maxHeight: '100%', maxWidth: '100%' }}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  </Box>
);
